import { configureStore } from "@reduxjs/toolkit";
import pdfSliceReducer from "../api/slice/otherPdfSlice.js";
import savedPdfsReducer from '../api/slice/savedPdfsSlice.js'; 

const store = configureStore({
    reducer: {
        pdf: pdfSliceReducer,
        savedPdfs: savedPdfsReducer, // Add the savedPdfs slice to the store
    },
});

export default store;
